import { analytics } from 'libs';
import Filter from './Filter';
import Toggle from './Toggle';

const options = [
  { key: 'purchase', value: 'Purchase', filter: { purchase: 1 } },
  { key: 'refinance', value: 'Refinance', filter: { refinance: 1 } },
  { key: 'transfer', value: 'Transfer', filter: { transfer: 1 } },
];

interface TransactionTypeFilters {
  purchase?: 0 | 1 | '0' | '1';
  refinance?: 0 | 1 | '0' | '1';
  transfer?: 0 | 1 | '0' | '1';
}

interface TransactionTypeFilterProps {
  filters: TransactionTypeFilters;
  onFilter: (update: Record<string, number | null>) => void;
}

const TransactionTypeFilter = ({ filters, onFilter }: TransactionTypeFilterProps) => {
  const onChange = (filter: string) => {
    const key = filter as keyof TransactionTypeFilters;
    analytics.productSearch.filter({
      transaction_type: filters[key] ? 'cleared' : filter,
    });
    onFilter({
      purchase: null,
      refinance: null,
      transfer: null,
      [filter]: filters[key] ? null : 1,
    });
  };

  const getValue = () => {
    return options.reduce<string[]>((accum, option) => {
      if (filters[option.key as keyof TransactionTypeFilters]) {
        accum.push(option.key);
      }
      return accum;
    }, []);
  };

  return (
    <Filter name="Transaction Type">
      <Toggle testId="filter-transaction-type" onChange={onChange} options={options} value={getValue()} />
    </Filter>
  );
};

export default TransactionTypeFilter;
